import { Box, Divider, Stack } from '@mui/material';
import { getYear, parseISO } from 'date-fns';
import _ from 'lodash';
import React, { useState } from 'react';
import Empty from '../../../../components/common/Empty';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { ApproveModal } from '../../../../components/modal/ApproveModal';
import { ModalText, useModalToggle } from '../../../../components/modal/Modal';
import {
  PrimaryButton,
  PrimaryOutlinedButton,
} from '../../../../components/style/ButtonStyle';
import {
  FacilityTabPanel,
  InfoText,
} from '../../../../components/style/TabStyle';
import { IconLabel } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import {
  EditIcon,
  GoBackIcon,
  InfomationIcon,
} from '../../../../layouts/dashboard/nav/IconButton';
import { fDate } from '../../../../utils/formatTime';

// ----------------------------------------------------------------------

export default function InstpectionInfoPanel({
  value,
  setMode,
  facility,
  inspections,
  setInspectionId,
  getResult,
}: any) {
  const [latest, setLatest] = useState(true);
  const thisYearInspections = _.filter(
    inspections,
    item => getYear(parseISO(item?.inspectionDate)) === getYear(new Date()),
  );
  const isEmpty = _.isEmpty(inspections);
  const isInspected = _.isEmpty(thisYearInspections);
  const isEmptyInspection = isEmpty || isInspected;

  return (
    <FacilityTabPanel value={value}>
      {latest ? (
        <>
          {isEmptyInspection ? (
            <Empty content="올해 점검이력이 없습니다." />
          ) : (
            <InspectionListItem
              list={thisYearInspections}
              setMode={setMode}
              setInspectionId={setInspectionId}
            />
          )}
          <Stack direction="row" spacing={1} mt={5}>
            <PrimaryButton
              startIcon={<EditIcon />}
              onClick={() => {
                setMode('ADD');
              }}
            >
              점검내용 작성
            </PrimaryButton>
            <PrimaryOutlinedButton
              startIcon={<GoBackIcon />}
              onClick={() => setLatest(false)}
            >
              이전 점검이력
            </PrimaryOutlinedButton>
          </Stack>
        </>
      ) : (
        <>
          <InspectionListItem
            list={inspections}
            setMode={setMode}
            setInspectionId={setInspectionId}
            getResult={getResult}
          />
          <Stack direction="row" justifyContent="center" mt={5}>
            <PrimaryOutlinedButton
              sx={{ maxWidth: '250px' }}
              startIcon={<GoBackIcon />}
              onClick={() => setLatest(true)}
            >
              뒤로가기
            </PrimaryOutlinedButton>
          </Stack>
        </>
      )}
    </FacilityTabPanel>
  );
}

function InspectionListItem({
  list,
  setMode,
  setInspectionId,
  getResult,
}: any) {
  return (
    <>
      {_.map(list, info => {
        return (
          <React.Fragment key={info?.inspectionId}>
            <Stack spacing={2.5}>
              <Stack direction="row" spacing={1} alignItems="center">
                <InfomationIcon />
                <IconLabel>자세한 정보</IconLabel>
                <Box />
              </Stack>
              <Stack spacing={0.5}>
                <InfoText>
                  점검일자 : {fDate(info?.inspectionDate, 'yyyy-MM-dd') || '-'}
                </InfoText>
                <InfoText>점검자 : {info?.inspectorName || '-'}</InfoText>
                <InfoText>점검상태 : {info?.inspectionScore || '-'}</InfoText>
                <InfoText sx={{ maxWidth: 320 }}>
                  상태비고 : {info?.inspectionResultTypes || '-'}
                </InfoText>
                <InfoText sx={{ maxWidth: 320 }}>
                  점검내용 : {info?.inspectionNote || '-'}
                </InfoText>
              </Stack>

              <Stack direction="row" justifyContent="space-between">
                <Box />
                <Stack direction="row" spacing={1} mb={2}>
                  <DeleteInspectionButtion
                    inspectionId={info?.inspectionId}
                    getResult={getResult}
                  />
                  <PrimaryButton
                    sx={{ width: '100px' }}
                    onClick={() => {
                      setMode('EDIT');
                      setInspectionId(info?.inspectionId);
                    }}
                  >
                    수정
                  </PrimaryButton>
                </Stack>
              </Stack>
            </Stack>
            <Divider sx={{ mb: 3 }} />
          </React.Fragment>
        );
      })}
    </>
  );
}

function DeleteInspectionButtion({ inspectionId, getResult }: any) {
  const [removeResult, remove] = useAuthAxios({
    method: 'DELETE',
    url: `/api/v1/inspection/${inspectionId}`,
  });
  const { on, open, close } = useModalToggle();
  return (
    <>
      <PrimaryOutlinedButton sx={{ width: '100px' }} onClick={open}>
        삭제
      </PrimaryOutlinedButton>
      <ApproveModal
        on={on}
        onClose={close}
        title="삭제하시겠습니까?"
        children={
          <Stack direction="row" justifyContent="center" sx={{ pt: 3, pb: 5 }}>
            <ModalText>삭제된 데이터는 복구되지 않습니다.</ModalText>
          </Stack>
        }
        onConfirm={() => {
          remove();
          close();
        }}
        isPrimaryColor={false}
      />

      <ApiResultModal
        apiResult={removeResult}
        successCode={200}
        successTitle={<>삭제 완료</>}
        successContent={`점검내역이 삭제되었습니다.`}
        successConfirmText="목록으로 돌아가기"
        onSuccessClose={getResult}
        failTitle={<>관리자에게 문의해주세요.</>}
        failContent={'문제가 발생했습니다. 관리자에게 문의해주세요.'}
      />
    </>
  );
}
